/* eslint-disable complexity */
import {
  BookWidgetAem,
  BookWidgetPassengerField
} from '@com-delta-idp/mnx-capability-flight-shop-ui';
import { Option } from '@com-delta-omnichannel/mach';
import { BookWidgetFieldsMasterConfig } from '../../models/book-widget-fields-master-config.interfaces';
import { CatalogApiFieldsValue } from '../../models/core-apis/catalog-api.interfaces';
import { DefaultLookupFieldsValue } from '../../models/core-apis/default-lookup.interfaces';
import { RetrieveSearchData } from '../../models/core-apis/retrieve-search.interfaces';
import { LoginDashboardFieldsConfig } from '../../models/login-dashboard.interfaces';
import { QueryParams } from '../../models/states/query-params-state.interfaces';

export const preparePassengerField = (
  bookWidgetAem: BookWidgetAem | null,
  queryParams: QueryParams | null,
  defaultLookupFieldsValue: DefaultLookupFieldsValue | null,
  retrieveSearchData: RetrieveSearchData | null,
  catalogApiFieldsValue: CatalogApiFieldsValue | null,
  bookWidgetFieldsMasterConfig: BookWidgetFieldsMasterConfig,
  loginDashboardFieldsConfig: LoginDashboardFieldsConfig | null,
  hasDeepLinkingParams: boolean
): BookWidgetPassengerField => {
  let paxMaxCount = Number(bookWidgetAem?.defaultValues?.maxPaxCount);
  let paxMinCount = 1;

  if (loginDashboardFieldsConfig?.restrictPaxToOne) {
    paxMaxCount = 1;
    paxMinCount = 1;
  } else if (defaultLookupFieldsValue?.maxPaxCount) {
    paxMaxCount = defaultLookupFieldsValue.maxPaxCount;
    paxMinCount = defaultLookupFieldsValue.minPaxCount || paxMinCount;
  } else if (catalogApiFieldsValue?.maxPaxCount) {
    paxMaxCount = catalogApiFieldsValue.maxPaxCount;
  }

  const dropdownOptions: Option[] = [];
  const { passengerField: { passenger = '', passengersLabel = '' } = {} } =
    bookWidgetAem || {};

  for (let i = Number(paxMinCount); i <= Number(paxMaxCount); i++) {
    const label = i === 1 ? `${i} ${passenger}` : `${i} ${passengersLabel}`;
    dropdownOptions.push({
      label,
      value: i.toString()
    });
  }

  let selectedPaxValue = '';

  if (loginDashboardFieldsConfig?.restrictPaxToOne) {
    selectedPaxValue = '1';
  } else if (
    !bookWidgetFieldsMasterConfig?.passengerField?.disable &&
    queryParams?.paxCount
  ) {
    selectedPaxValue = queryParams?.paxCount.toString();
  } else if (!hasDeepLinkingParams) {
    if (
      bookWidgetFieldsMasterConfig?.passengerField?.disable &&
      defaultLookupFieldsValue?.selectedPaxValue
    ) {
      selectedPaxValue = defaultLookupFieldsValue.selectedPaxValue.toString();
    } else if (
      !bookWidgetFieldsMasterConfig?.passengerField?.disable &&
      retrieveSearchData?.passenger
    ) {
      selectedPaxValue = retrieveSearchData.passenger.toString();
    } else if (defaultLookupFieldsValue?.selectedPaxValue) {
      selectedPaxValue = defaultLookupFieldsValue.selectedPaxValue.toString();
    } else if (catalogApiFieldsValue?.selectedPaxValue) {
      selectedPaxValue = catalogApiFieldsValue.selectedPaxValue.toString();
    } else if (bookWidgetAem?.defaultValues?.selectedPaxValue) {
      selectedPaxValue =
        bookWidgetAem.defaultValues.selectedPaxValue.toString();
    }
  }

  let indexOfSelectedPaxValue = -1;
  if (selectedPaxValue) {
    indexOfSelectedPaxValue = dropdownOptions.findIndex(
      ({ value }) => value === selectedPaxValue
    );
  }

  if (indexOfSelectedPaxValue === -1) {
    selectedPaxValue = dropdownOptions[0].value;
    dropdownOptions[0].selected = true;
  } else {
    dropdownOptions[indexOfSelectedPaxValue].selected = true;
  }

  return {
    dropdownOptions,
    selectedPaxValue,
    disable: bookWidgetFieldsMasterConfig.passengerField?.disable || false
  };
};
